module.exports = __webpack_public_path__ + "img/xsh_p00.23b6e40d.jpg";